<template>
  <div class="identification-finish">
    <div class="tips-content" v-if="type === 'cert'">
      <div class="icon-content">
        <i class="icon icon-yanzhengtongguo"></i>
      </div>
      <div class="text-content">
        <div class="text">
          {{ $t('crm_identification_finish.zltjcgddhtrgsh') }}
        </div>
        <div class="tips" v-html="htmlTips1" @click="detail"></div>
      </div>
    </div>
    <div class="tips-content" v-else>
      <div class="icon-content">
        <i class="icon icon-yanzhengtongguo"></i>
      </div>
      <div class="text-content">
        <div class="text">
          {{ $t('crm_identification_finish.zltjcgddbbszzs') }}
        </div>
        <div class="tips" v-html="htmlTips2" @click="detail"></div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  props: {
    // seal cert
    // type: {
    //   type: String,
    //   default: 'seal'
    // }
  },
  computed: {
    type() {
      return this.injectData.submissionIndex === 1 ? 'cert' : '';
    },
    htmlTips1() {
      return this.$t('crm_identification_finish.wxtxshtghssxxspanzck');
    },
    htmlTips2() {
      return this.$t('crm_identification_finish.wxtxszzskzsxxspanzck');
    }
  },
  inject: ['backToCompany', 'injectData'],
  methods: {
    detail(e) {
      const className = e.target.className;
      if (className.includes('company-msg')) {
        this.$router.push('/companyInfo/msg');
      }
    }
  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
.identification-finish {
  margin-top: 24px;
  .tips-content {
    width: 100%;
    height: 166px;
    background: rgba(248, 249, 251, 1);
    border: 1px solid rgba(228, 235, 242, 1);

    .icon-content {
      $r: 35px;
      float: left;
      margin-left: 281px;
      margin-top: 62px;
      width: $r;
      height: $r;

      .icon {
        color: #16d071;
        font-size: 32px;
      }
    }

    .text-content {
      overflow: hidden;
      padding-left: 22px;
      .text {
        color: #495057;
        font-size: 16px;
        font-weight: bold;
        margin-top: 59px;
      }
      .tips {
        color: #6c757d;
        font-size: 12px;
        line-height: 16px;
        margin-top: 8px;

        /deep/ .company-msg {
          color: #0d9ae0;
          text-decoration: underline;
          padding: 0 4px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
